// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vj-0";
export var checkoutRateBadgeLink = "_vj-1";